import { Platform } from 'react-native';

/**
 * Team note:
 * - For web dev, we default to localhost.
 * - For Android emulator, we use 10.0.2.2.
 * - For iPhone / physical device testing on your local network, update the
 *   host below to your machine's LAN IP, for example: 192.168.1.42
 *
 * If you prefer not to edit this file, you can also override the web values:
 * - EXPO_PUBLIC_API_BASE_URL=http://YOUR_IP:3000/api/
 * - EXPO_PUBLIC_SOCKET_URL=http://YOUR_IP:3000/
 */
const LOCAL_DEV_API_HOST = '192.168.0.103:3000';

const localDeviceApiBaseUrl = `http://${LOCAL_DEV_API_HOST}/api/`;
const localDeviceSocketUrl = `http://${LOCAL_DEV_API_HOST}/`;
const webApiBaseUrl =
  process.env.EXPO_PUBLIC_API_BASE_URL || 'http://localhost:3000/api/';
const webSocketUrl =
  process.env.EXPO_PUBLIC_SOCKET_URL || 'http://localhost:3000/';

// Native builds honour the same overrides so a physical device can be pointed
// at a LAN host (or a deployed environment) without editing this file.
const overrideApiBaseUrl = process.env.EXPO_PUBLIC_API_BASE_URL;
const overrideSocketUrl = process.env.EXPO_PUBLIC_SOCKET_URL;

export default {
  apiBaseUrl:
    overrideApiBaseUrl ||
    (Platform.OS === 'android'
      ? 'http://10.0.2.2:3000/api/'
      : Platform.OS === 'web'
        ? webApiBaseUrl
        : localDeviceApiBaseUrl),
  socketUrl:
    overrideSocketUrl ||
    (Platform.OS === 'android'
      ? 'http://10.0.2.2:3000/'
      : Platform.OS === 'web'
        ? webSocketUrl
        : localDeviceSocketUrl),
  webUrl: 'http://localhost:3002/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  expires: 365,
  secure: false,
  nutritionixAppId: '94e4784e',
  nutritionixAppKey: '06b5b7dd2280bfd224041a02ac9b740f',
  withingsClientId:
    'ce6f499a15768464925837c758d215f906cc1f25ea9e44c5f81ee3d680ab8992',
  withingsRedirectUrl: 'https://staging-api.qhlth.com/api/withings/callback',
  fitbitAppClientId: '23QW5Q',
  fitbitRedirectWebUri: 'https://localhost:19006/*',
  fitbitRedirectAppUri: 'com.qhlth.development://home',
  privacyPolicyUrl: 'https://quratehealth.com/privacy',
  loginAgreements: {
    privacyPolicy: 'https://quratehealth.com/privacy'
  },
  debug: true,
  iosAppLink: 'https://appdistribution.firebase.dev/i/bea975c84a18a4a7',
  androidAppLink: 'https://appdistribution.firebase.dev/i/cc868ad768dd6bf6',
  videoCallProvider: 'zoom',
  zoomAppGroupId: 'com.qhlth.development'
};
